<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.contract.selected_contracts' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
@if(contracts?.length > 0){
    <div class="overflow-y-auto zuper-scrollbar data-picker-list-content-height">
        @if(associatedContracts?.length > 0 && isFromNote && notesPickerPreferences[module]?.preference?.contract === 'BOTH'){
            <div class="flex justify-between items-center" [ngClass]="{'border-b border-gray-200': !isAssociatedExpanded}">
                <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                    @if(associatedContracts.length > 1){
                        {{'contracts.text' | translate}}
                    } @else{
                        {{'contract' | translate}}
                    }
                    {{ notesPickerPreferences[this.module].label | translate}}
                </div>
                <div class="relative cursor-pointer py-3 px-5 flex items-center space-x-2 text-gray-700 transition-all"
                    (click)="isAssociatedExpanded = !isAssociatedExpanded"
                    [ngClass]="{ 'custom-expanded-top': isAssociatedExpanded }">
                    <div class="flex flex-col items-center text-blue-500">
                        <ng-container *ngIf="!isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up rotate-180"></i>
                            <i class="-mt-3 text-base font-medium leading-6 ti ti-chevron-down rotate-180"></i>
                        </ng-container>
                        <ng-container *ngIf="isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up"></i>
                            <i class="-mt-3 text-base leading-6 font-medium ti ti-chevron-down"></i>
                        </ng-container>
                    </div>
                    <span class="text-base font-medium text-blue-500">
                        {{ isAssociatedExpanded ? ('collapse' | translate) : ('expand' | translate) }}
                    </span>
                </div>
            </div>
            @if(isAssociatedExpanded){
                <ul role="list" class="border-b border-gray-200">
                    <li class="contract-data-picker-list-ele border-b border-gray-200" *ngFor="let contract of associatedContracts;let index = index">
                        <ng-container *ngTemplateOutlet="contractTemplate; context: { contract: contract, index:index, isAssociated: true }"></ng-container>
                    </li>
                </ul>
            }
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                {{'text.picker.association.all.contracts' | translate}}
            </div>
        }
        @if(notesPickerPreferences[module]?.preference?.contract === 'LINKED' && isFromNote){
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                @if(contracts.length > 0){
                    {{'contracts.text' | translate}}
                } @else{
                    {{'contract' | translate}}
                }
                {{ notesPickerPreferences[module].label | translate}}
            </div>
        }
        <ul role="list" class="divide-y divide-gray-200 " [ngClass]="{ 'data-picker-max-count': isMaxSelectionLimit }"
            *ngIf="contracts.length">
            <li class="contract-data-picker-list-ele" *ngFor="let contract of contracts;let index = index">
                <ng-container *ngTemplateOutlet="contractTemplate; context: { contract: contract, index:index, isAssociated: false }"></ng-container>
            </li>
        </ul>
    </div>
}
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!contracts.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_contracts_or_quote_found.svg" alt="No Contracts Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.contract.not_found' |
            translate}} '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.contract.placeholder' |
            translate}}
        </h4>
    </div>
</div>

<ng-template #contractTemplate let-contract="contract" let-index="index" let-isAssociated="isAssociated">
    <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
    [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
    (click)="selectOption === 'readOnly' ? viewContractDetails($event, contract.contract_uid) : null">
    <a class="-m-1 block flex-1 p-1 w-full">
        <div class="relative flex min-w-0 flex-1 items-center">
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'multiSelect'">
                <span class="flex items-center justify-center px-1">
                    <input 
                        type="checkbox" 
                        class="picker-data-selection-size" 
                        [id]="isAssociated ? 'contract_data_select_associated_' + index : 'contract_data_select_' + index"
                        (change)="selectContract($event, contract)" 
                        [checked]="isSelectedContract(contract)" />
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="contractsContent"></ng-container>
                </div>
            </div>
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'select'">
                <span class="flex items-center justify-center px-1">
                    <input 
                        type="radio" 
                        class="picker-data-selection-size" 
                        [id]="isAssociated ? 'contract_data_select_associated_' + index : 'contract_data_select_' + index"
                        (change)="selectContract($event, contract)" 
                        [checked]="isSelectedContract(contract)" />
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="contractsContent"></ng-container>
                </div>
            </div>
            <ng-container *ngIf="selectOption === 'readOnly'">
                <div class="ml-2 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="contractsContent"></ng-container>
                </div>
            </ng-container>
            <ng-template #contractsContent>
                <div class="flex items-center justify-between">
                    <div class="w-full">
                        <div class="flex flex-row space-x-2 w-11/12">
                            <label class="truncate text-lg font-medium text-gray-900 cursor-pointer" [for]="isAssociated ? 'contract_data_select_associated_' + index : 'contract_data_select_' + index">
                                {{contract.contract_number}} - {{contract.contract_name}}
                            </label>
                        </div>
                        <div class="flex flex-row space-x-2 mt-1" *ngIf="contract.ref_no">
                            <label class="flex items-center cursor-pointer text-gray-500" *ngIf="contract.ref_no"
                            [matTooltip]="('text.reference_number' | translate)">
                                <em class="ti ti-receipt mr-1 icon-size-4"></em>
                                <span class="truncate text-base">
                                    {{contract.ref_no}}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </ng-template>
            <button mat-icon-button class="cursor-pointer ml-auto"
                matTooltip="{{ updateArrowTooltipText(contract.contract_uid, isAssociated) | translate }}"
                matTooltipPosition="left" *ngIf="!showSpinLoading(contract.contract_uid, isAssociated)"
                [ngClass]="rotateArrowIcon(contract.contract_uid, isAssociated)"
                (click)="viewContractDetails($event, contract.contract_uid, isAssociated)">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down" width="24"
                        height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </mat-icon>
            </button>
            <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(contract.contract_uid, isAssociated)">
                <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px"></mat-spinner>
            </div>
        </div>
    </a>    
</div>
<div class="p-4 bg-gray-100"
    *ngIf="(('contract_details_' + contract.contract_uid === contractEleId && !isAssociated) || ('contract_details_associated_' + contract.contract_uid === contractEleId && isAssociated)) && contractDetails && !isSpinLoading">
    <div class="bg-card rounded relative">
        <a target="_blank" class="hidden" #contractViewFullDetails
            href="{{viewContractFullDetails(contract.contract_uid)}}"></a>
        <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="contractViewFullDetails.click($event)"
            matTooltip="{{'text.view_details.new_tab' | translate}}"
            matTooltipPosition="left">
            <button mat-icon-button>
                <mat-icon class="text-xl">open_in_new</mat-icon>
            </button>
        </span>
        <div class="text-base">
            <div class="px-2 truncate flex flex-wrap">
                <div *ngIf="contractDetails.description"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover w-full">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'description' | translate}} </p>
                    <div class="mt-1 text-gray-900 inner-html-overflow" [innerHTML]="contractDetails.description | safeHtml">
                    </div>
                </div>
                <div *ngIf="contractDetails.customer?.customer_first_name"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'customer' | translate}}</p>
                    <p class="mt-1 text-gray-900"
                        *ngIf="contractDetails.customer.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                        {{contractDetails.customer.customer_first_name}}
                        {{contractDetails.customer.customer_last_name ?? ''}}</p>
                    <p class="mt-1">
                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                            [routerLink]="utilityService.getLink('CUSTOMER', contractDetails.customer.customer_uid)"
                            *ngIf="!contractDetails.customer.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                            {{contractDetails.customer.customer_first_name}}
                            {{contractDetails.customer.customer_last_name ?? ''}}</a>
                    </p>
                </div>
                <div *ngIf="contractDetails.organization"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.organization_name' | translate}}</p>
                    <p class="mt-1 text-gray-900"
                        *ngIf="contractDetails.organization.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                        {{contractDetails.organization?.organization_name}}</p>
                    <p class="mt-1">
                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                            [routerLink]="utilityService.getLink('ORGANIZATION', contractDetails.organization.organization_uid)"
                            *ngIf="!contractDetails.organization.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                            {{contractDetails.organization?.organization_name}}</a>
                    </p>
                </div>
                <div
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.contract_status' | translate}} </p>
                    <div class="mt-2">
                        <badge [options]="getStatusBadgeOptions(contractDetails.is_active ? 'ACTIVE' : 'INACTIVE', (contractDetails.is_active ? 'active.text' :
                                                    'text.inactive')
                                                    |
                                                    translate)">
                        </badge>
                    </div>
                </div>
                <div *ngIf="contractDetails.contract_package"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'dataPicker.contract.content.package_name' | translate}}</p>
                    <p class="mt-1 text-gray-900 truncate">
                        {{contractDetails.contract_package?.package_name}}</p>
                </div>
                <div *ngIf="contractDetails.start_date"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.start_date' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                        {{contractDetails.start_date | dateformat}}</p>
                </div>
                <div *ngIf="contractDetails.end_date"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'expiry_date' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                        {{contractDetails.end_date | dateformat}}</p>
                </div>
                <div *ngIf="!utilityService.isEmptyOrUndefined(contractDetails.term_months)"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'dataPicker.contract.content.contract_term' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                       {{contractDetails.term_months}} {{'text.months' | translate}}</p>
                </div>
                <div *ngIf="contractDetails.template?.template_name"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'dataPicker.contract.content.contract_template' | translate}} </p>
                    <p class="mt-1 text-gray-900 truncate">
                       {{contractDetails.template?.template_name}}</p>
                </div>
                <div *ngIf="contractDetails.approval_status"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'approval.status' | translate}} </p>
                    <badge [options]="getApprovalStatusOptions(contractDetails.approval_status)">
                    </badge>
                </div>
                <div *ngIf="contractDetails.invoice_settings"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'dataPicker.contract.content.invoice_created' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                        {{(contractDetails.invoice_settings?.auto_generate ? 'yes' :
                        'No') | translate}}</p>
                </div>
                <div *ngIf="contractDetails.invoice_settings?.billing_period?.billing_period_name"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'dataPicker.contract.content.billing_period' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                       {{contractDetails.invoice_settings?.billing_period?.billing_period_name}}</p>
                </div>
                <div *ngIf="contractDetails.invoice_settings?.payment_term?.payment_term_name"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.payment_term' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                       {{contractDetails.invoice_settings?.payment_term?.payment_term_name}}</p>
                </div>
                <div *ngIf="contractDetails.created_at"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'created.at.text' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                        {{contractDetails.created_at | datetime}}</p>
                </div>
                <div *ngIf="contractDetails.created_by?.first_name"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer contract-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'created.by.text' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                        {{contractDetails.created_by.first_name}}
                        {{contractDetails.created_by?.last_name ?? ''}}</p>
                </div>
            </div>
        </div>
        <div class="px-2 py-2 border-t text-base"
            *ngIf="contractDetails.customer_address && (contractDetails.customer_address.street || contractDetails.customer_address.state)">
            <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                {{'text.service_address' | translate}} </p>
            <div class="px-3">
                <p *ngIf="contractDetails.customer_address.first_name" class="text-base mb-2">
                    {{contractDetails.customer_address.first_name}}
                    {{contractDetails.customer_address.last_name ?? ''}}</p>
                <p *ngIf="contractDetails.customer_address.street" class="text-base mb-2">
                    {{contractDetails.customer_address.street}}</p>
                <p *ngIf="contractDetails.customer_address.landmark" class="text-base mb-2">
                    {{contractDetails.customer_address.landmark}}</p>  
                <p *ngIf="contractDetails.customer_address.city" class="text-base mb-2">
                    {{contractDetails.customer_address.city}}</p>
                <p *ngIf="contractDetails.customer_address.state" class="text-base mb-2">
                    {{contractDetails.customer_address.state}}
                    {{contractDetails.customer_address.zip_code ? '- ' +
                    contractDetails.customer_address.zip_code : '' }}</p>
                <p *ngIf="contractDetails.customer_address.country" class="text-base">
                    {{contractDetails.customer_address.country}}</p>
            </div>
        </div>
        <div class="px-2 py-2 border-t text-base"
            *ngIf="contractDetails.billing_address && (contractDetails.billing_address.street || contractDetails.billing_address.state)">
            <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                {{'billing.address.text' | translate}} </p>
            <div class="px-3">
                <p *ngIf="contractDetails.billing_address.first_name" class="text-base mb-2">
                    {{contractDetails.billing_address.first_name}}
                    {{contractDetails.billing_address.last_name}}</p>
                <p *ngIf="contractDetails.billing_address.street" class="text-base mb-2">
                    {{contractDetails.billing_address.street}}</p>
                <p *ngIf="contractDetails.billing_address.landmark" class="text-base mb-2">
                    {{contractDetails.billing_address.landmark}}</p>
                <p *ngIf="contractDetails.billing_address.city" class="text-base mb-2">
                    {{contractDetails.billing_address.city}}</p>
                <p *ngIf="contractDetails.billing_address.state" class="text-base mb-2">
                    {{contractDetails.billing_address.state}}
                    {{contractDetails.billing_address.zip_code ? '- ' +
                    contractDetails.billing_address.zip_code : '' }}</p>
                <p *ngIf="contractDetails.billing_address.country" class="text-base">
                    {{contractDetails.billing_address.country}}</p>
            </div>
        </div>
    </div>
</div>
</ng-template>